import request from "../request";

export const update = async (payload: Record<string, any>): Promise<boolean> => {
  try {
    const { status, data } = await request.post("/customer-service", payload);
    return !!(status === 200 && data.success);
  } catch (err) {
    console.error(err);
    return false;
  }
};
